import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { handleRequest } from "./retrieveNotificationsRequested";
import { handleSuccess } from "./retrieveNotificationsSucceeded";
import { handleFailure } from "./retrieveNotificationsFailed";
import { handleMarkNotificationsAsRead } from "./markNotificationsAsReadSucceeded";
import { createSelector } from "./selector";

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveNotificationsRequested]: handleRequest,
    [events.retrieveNotificationsSucceeded]: handleSuccess,
    [events.retrieveNotificationsFailed]: handleFailure,
    [events.markNotificationsAsReadSucceeded]: handleMarkNotificationsAsRead,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
